import { Checkbox, FormControl, FormControlLabel, FormHelperText, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { FunctionComponent, SetStateAction } from 'react'
import gaiaTheme from '../../../../root-components/theme'
import FormEditButtons from './form-edit-buttons'

export const FormCheckBoxInputDisplay: FunctionComponent<{
  isEditPage: boolean,
  allowEdit?: boolean,
  editField?: string | undefined,
  setEditField?: React.Dispatch<SetStateAction<any>> | undefined,
  hideEditIcon?: boolean,
  disabled: boolean,
  isLastField?: boolean,
  title: string,
  name: string,
  label: string,
  value: boolean,
  touched?: any,
  errors?: any,
  onChange: any,
  customErrorMessage?: string,
  cancelEditHandler?: () => void,
  bottomBorder?: boolean,
  topBorder?: boolean,
  sideBorders?: boolean,
  isTopRow?: boolean,
  isBottomRow?: boolean,
}> = ({
  isEditPage,
  allowEdit = true,
  editField,
  setEditField,
  hideEditIcon = false,
  disabled,
  isLastField = false,
  title,
  name,
  label,
  value,
  touched,
  errors,
  onChange,
  customErrorMessage,
  cancelEditHandler,
  bottomBorder = false,
  topBorder = true,
  sideBorders = true,
  isTopRow = false,
  isBottomRow = false,
}) => {

    const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));

    const toggleEditField = (fieldName: string) => {
      if (setEditField) {
        setEditField(fieldName)
      }
    }

    return (
      <FormControl fullWidth variant='outlined'>
        <Stack sx={{
          borderWidth: '1px',
          borderBottomStyle: bottomBorder || isBottomRow ? 'solid' : 'none',
          borderColor: 'lightGrey.main',
          borderLeftStyle: sideBorders ? 'solid' : 'none',
          borderRightStyle: sideBorders ? 'solid' : 'none',
          borderTopStyle: topBorder || isTopRow ? 'solid' : 'none',
          pt: 1, pb: 1, pl: 3,
          borderTopLeftRadius: isTopRow ? '10px' : 0,
          borderTopRightRadius: isTopRow ? '10px' : 0,
          borderBottomLeftRadius: isBottomRow ? '10px' : 0,
          borderBottomRightRadius: isBottomRow ? '10px' : 0
        }}>
          <Stack position='relative' alignItems={isMobileMode ? 'flex-start' : 'center'} flexDirection={isMobileMode ? 'column' : 'row'} justifyContent='start'>
            <Typography variant='subtitle1' sx={{ width: isMobileMode ? '100%' : '40%', minWidth: '100px', color: 'text.primary' }}> {title} </Typography>
            <Stack position='relative' flexDirection='column' sx={{ width: '100%' }}>
              <Stack position='relative' flexDirection='row' justifyContent='start' alignItems='center'>
                <FormControlLabel
                  sx={{
                    mt: 1, mb: 1, mr: 15, ml: 1,
                    ...((editField !== 'isPrimaryLocation') && {
                      '& .MuiOutlinedInput-notchedOutline': { border: 'none' }
                    }),
                    ...((editField === 'isPrimaryLocation') && {
                      '& .MuiOutlinedInput-notchedOutline': { borderColor: 'text.secondary' }
                    }),
                    color: 'text.secondary'
                  }}
                  control={<Checkbox name={name} onChange={onChange} disabled={disabled} checked={value} />} label={label} />
                {allowEdit &&
                  <FormEditButtons
                    isEditPage={isEditPage}
                    editField={editField}
                    hideEditIcon={hideEditIcon}
                    name={name}
                    toggleEditField={toggleEditField}
                    cancelEditHandler={cancelEditHandler}
                  />}
              </Stack>
              {touched && errors &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                  {errors ? <div>{errors as string}</div> : null}
                </FormHelperText>
              }
              {customErrorMessage &&
                <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>{customErrorMessage}
                </FormHelperText>
              }
            </Stack>
          </Stack>
        </Stack>
      </FormControl>
    )
  }